import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import gidambuLogo from "../assets/gidambu_logo.jpeg";    

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const apiBaseUrl = "https://gidanbu-backend.onrender.com/api/auth/admin/login";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(apiBaseUrl, { email, password });
      if (response.status === 200) {
        const { token, _id, name, role, refreshToken } = response.data;

        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("token", token);
        localStorage.setItem("id", _id);
        localStorage.setItem("username", name);
        localStorage.setItem("role", role);
        localStorage.setItem("refreshToken", refreshToken);

        window.dispatchEvent(new Event("authChange"));
        navigate("/dashboard");
      }
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100 p-3"
      style={{
        background: "linear-gradient(135deg, #002b80 0%, #005ce6 100%)",
        color: "#fff",
      }}
    >
      <div
        className="card shadow-lg border-0 p-4 w-100"
        style={{
          maxWidth: "420px",
          borderRadius: "20px",
          backgroundColor: "#ffffff",
        }}
      >
        <div className="text-center mb-4">
          <img
            src={gidambuLogo}
            alt="Gidanbu Logo"
            className="rounded-circle border border-3 border-primary"
            style={{
              width: "70px",
              height: "70px",
              objectFit: "cover",
            }}
          />
          <h4 className="mt-3 text-dark fw-bold">Gidanbu Admin</h4>
          <p className="text-muted small mb-0">
            Sign in to access your dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-dark fw-semibold">Email</label>
            <div className="input-group">
              <span className="input-group-text bg-white text-primary">
                <FaUser />
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label text-dark fw-semibold">Password</label>
            <div className="input-group">
              <span className="input-group-text bg-white text-primary">
                <FaLock />
              </span>
              <input
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          {error && <p className="text-danger text-center small">{error}</p>}

          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="rememberMe"
              />
              <label
                htmlFor="rememberMe"
                className="form-check-label text-muted small ms-1"
              >
                Remember me
              </label>
            </div>
            <a
              href="#"
              className="text-primary text-decoration-none small mt-2 mt-sm-0"
            >
              Forgot password?
            </a>
          </div>

          <button
            type="submit"
            className="btn w-100 fw-semibold text-white py-2"
            style={{
              backgroundColor: "#002b80",
              borderRadius: "8px",
            }}
          >
            Sign In
          </button>
        </form>

        <div className="text-center mt-3">
          <p className="text-muted small mb-0">
            Don’t have an account?{" "}
            <a href="/signup" className="text-primary fw-semibold">
              Register
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
